import Select from "react-select";
import {customTheme} from "../../../../../IntReports/LocationTab";
import styled from "styled-components";
import {useQuery} from "react-query";
import apiService from "../../../../../../../api/apiService";
import {useContext, useEffect} from "react";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import {
    technicalEngagementByAccountID,
    technicalEngagementByOpportunityID
} from "../../../../../../../utils/const/query-key";

const TechnicalEngagementDropdownStyle = styled.div`
  width: 100%;
`;

const TechnicalEngagementDropdown = (props) => {
    const {technicalEngagementValue, setTechnicalEngagementValue,TechnicalEngagementByOptIdData,TechnicalEngagementByAccountIdData, customerName} = props;
    const {technicalEngagement, setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const {
        refetch: refetchTechnicalEngagementByOptId,
    } = useQuery(technicalEngagementByOpportunityID, () =>
            apiService.getTechnicalEngagementByOpptId(technicalEngagement.opportunity),
        {enabled: false}
    );

    const {
        refetch: refetchTechnicalEngagementByAccountId,
    } = useQuery(technicalEngagementByAccountID, () =>
            apiService.getTechnicalEngagementByAccountId(technicalEngagement.accountName),
        {enabled: false}
    );

    useEffect(() => {
            if (technicalEngagement.opportunity !== "") {
                refetchTechnicalEngagementByOptId();
            }
            else{
                refetchTechnicalEngagementByAccountId();
            }
        }
        , [technicalEngagement.opportunity]);

    const handleSelect = (val) => {
        setTechnicalEngagementValue(val);
        setTechnicalEngagement(prevState => {
            return{
                ...prevState,
                technicalEngagementId: val.value
            }
        });
    }
    const options = (TechnicalEngagementByOptIdData?.length > 0 && technicalEngagement.opportunity !=="") ? TechnicalEngagementByOptIdData :  TechnicalEngagementByAccountIdData;
    return (
        <TechnicalEngagementDropdownStyle>
            <Select
                id={"technicalEngagement_link_dropdown"}
                placeholder={<div>Select Technical Engagement</div>}
                options={options?.map((technicalEngagement) => {
                    return {
                        label: technicalEngagement,
                        value: technicalEngagement.technicalEngagementId
                    }
                })}
                getOptionLabel={(option) => `${option?.label?.name} ${option?.label?.subject === null ? "" : " - " + option?.label?.subject}`}
                onChange={handleSelect}
                theme={customTheme}
                isDisabled={technicalEngagement.accountName === "" || customerName === ""}
                value={ technicalEngagementValue.value === undefined  ? "" :  technicalEngagementValue }
            />
        </TechnicalEngagementDropdownStyle>
    );

}
export default TechnicalEngagementDropdown;
